import { type FC, type PropsWithChildren, type ReactElement, type ReactNode } from "react";

import { Headline, HeadlineWrapper, Wrapper } from "./ContentWrapper.sc";

export interface ContentWrapperProps {
    title?: string | ReactElement;
    link?: ReactNode;
    titleStyle?: "default" | "dashboard";
    marginVariant?: "default" | "table";
}

export const ContentWrapper: FC<PropsWithChildren<ContentWrapperProps>> = ({ title, link, titleStyle, marginVariant = "default", children }) => (
    <Wrapper square={false} $marginVariant={marginVariant}>
        <HeadlineWrapper>
            {title && (
                <Headline color="primary" variant="h5" $titleStyle={titleStyle}>
                    {title}
                </Headline>
            )}
            {link}
        </HeadlineWrapper>
        {children}
    </Wrapper>
);
